import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';

const IsvFixedFeeThresholdField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return (
		<FullInfoField
			label="isvFixedFeeThresholdLabel"
			value={restaurantForFullInfo?.vivaWalletIsv?.isvFixedFeeThreshold}
		/>
	);
};

export default IsvFixedFeeThresholdField;
